<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "ClAdvertiseSliderItem",
  props: {
    /**
     * @description slider item
     * @type {Object}
     * */
    item: {
      type: Object,
      default() {
        return {};
      }
    },
  },
  methods: {
    advertiseImage(image) {
      return (new URL(`../../assets/images/media/${image}`, import.meta.url)).toString()
    },
  }
})
</script>

<template>
  <a target="_blank" :href="item.link"
     class="cl-advertising-item">
    <img :alt="item.alt" :src="advertiseImage(item.img)" width="102" >
  </a>
</template>

<style scoped lang="scss">
  .cl-advertising-item {
    transition: all 0.2s linear;
    &:hover {
      transform: scale(1.2);
    }
  }
</style>
